import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function TraiesteFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Este un curs spiritual sau practic?',
    a: 'Este ambele. Combină concepte spirituale, cum sunt cele 7 legi ale succesului și conștiința bogăției, cu exerciții concrete pe care le aplici zilnic. Nu rămâi la nivel de teorie. Practici, simți și vezi rezultate.'
  }, {
    q: 'Pot aplica dacă sunt la început în dezvoltare personală?',
    a: 'Da. Totul este explicat simplu, clar, pas cu pas. Nu ai nevoie de experiență anterioară. Singura condiție este să fii deschis/ă la ideea că modul în care gândești și simți influențează viața ta.'
  }, {
    q: 'Ce sunt cele 7 legi spirituale ale succesului?',
    a: 'Sunt șapte principii care te ajută să trăiești în armonie cu tine și cu viața, și să atragi prosperitate în mod natural. În curs le descoperi pe fiecare, înțelegi cum funcționează și înveți cum să le aplici zilnic.'
  }, {
    q: 'Este doar despre bani sau despre viață în ansamblu?',
    a: 'Este despre viață în ansamblu. Bani, sănătate, iubire, sens, echilibru. Prosperitatea adevărată înseamnă abundență pe toate planurile, nu doar pe cel financiar.'
  }, {
    q: 'În cât timp apar rezultatele?',
    a: 'Unele schimbări apar imediat, mai ales în claritate, liniște interioară și felul cum te simți. Transformările mai profunde, în relații, în bani, în sănătate, se dezvoltă în timp pe măsură ce practici zilnic.'
  }, {
    q: 'Pot cumpăra doar acest curs fără tot pachetul Academiei?',
    a: 'Da. Cursul se poate achiziționa separat la 500 lei cu acces pe viață. Dacă vrei toate cele 6 cursuri plus întâlniri de grup, Programul Standard complet costă 1.985 lei integral și economisești față de cumpărarea separată.'
  }, {
    q: 'Am nevoie de un spațiu special sau de echipamente pentru exerciții?',
    a: 'Nu. Ai nevoie doar de un loc liniștit în care poți sta 15-30 de minute fără să fii deranjată. Exercițiile se fac acasă, în ritmul tău, fără echipament special.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-2027">
      <div className="max-w-4xl mx-auto px-6" data-id="element-2028">
        <SectionHeading title="Întrebări Frecvente" data-id="element-2029" />

        <div className="space-y-4 mb-16" data-id="element-2030">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-brand-text/10 rounded-2xl overflow-hidden bg-brand-cream/50" data-id="element-2031">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-2032">
                <span className="font-bold text-lg text-brand-text pr-8" data-id="element-2033">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-2034" />
              </button>
              <AnimatePresence data-id="element-2035">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-2036">
                    <div className="px-6 pb-5 text-brand-textSec leading-relaxed" data-id="element-2037">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-2038">
          <CTAButton data-id="element-2039" />
        </motion.div>
      </div>
    </section>;
}